import { SectionMedia } from '@sbercloud/uikit-product-site-section';
import { useLayoutType } from 'src/hooks/useLayoutType';

import { FullScreenProps } from './type';

const DEFAULT_PREVIEW_IMAGE =
  'https://cdn.cloud.ru/backend/images/video-player/preview_default.png';

export function FullScreen({
  id,
  title,
  image,
  description,
  videoLink,
  previewImage = DEFAULT_PREVIEW_IMAGE,
  controls = false,
  autoPlay = false,
}: FullScreenProps) {
  const layoutType = useLayoutType();
  const videoPlayerId = videoLink ? 'video-player' : '';

  return (
    <SectionMedia
      data-test-id="section-fullscreen"
      id={id ?? videoPlayerId}
      layoutType={layoutType}
      title={title}
      description={description}
      image={
        (image
          ? { src: image, alt: title }
          : undefined) as typeof videoLink extends string ? never : undefined
      }
      video={
        videoLink
          ? {
              src: videoLink,
              poster: previewImage ?? image ?? '',
              controls,
              autoPlay,
              muted: autoPlay,
            }
          : undefined
      }
    />
  );
}
